export const VERIFICATION_APPROVAL_STATUSES = [
  "Approval Pending",
  "Approved",
  "Rejected",
];

const isVerificationApprovalStatus = (status) =>
  VERIFICATION_APPROVAL_STATUSES.includes(status);

export const resolveVerificationApprovalStatus = (
  data = {},
  navigationState = {},
) => {
  const safeData = data ?? {};
  const safeNavigationState = navigationState ?? {};

  const candidates = [
    safeData.verification_approval_status,
    safeData.approval_status,
    safeNavigationState.verification_approval_status,
    safeNavigationState.approval_status,
    safeNavigationState.status,
    safeData.current_status,
    safeData.status,
  ];

  for (const candidate of candidates) {
    if (isVerificationApprovalStatus(candidate)) {
      return candidate;
    }
  }

  return "Approval Pending";
};
